import React from 'react';
import { Layers, CreditCard, Percent, BarChart2, DollarSign, Users, BarChart, Shield } from 'lucide-react';
import ConfigCard from '../ConfigCard';

const PayrollTab = ({ configData, cardProps }) => (
  <div className="space-y-6">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <ConfigCard {...cardProps} title="Salary Structures" icon={Layers}
        items={configData.salaryStructures}
        category="salaryStructures"
        fields={['component_type_display']}
      />
      <ConfigCard {...cardProps} title="Allowance Types" icon={CreditCard}
        items={configData.allowanceTypes}
        category="allowanceTypes"
        fields={['allowance_type_description']}
      />
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <ConfigCard {...cardProps} title="CPF Contribution Rates" icon={Percent}
        items={configData.cpfRates}
        category="cpfRates"
        fields={['age_bracket_display', 'employee_rate', 'employer_rate']}
      />
      <ConfigCard {...cardProps} title="SHG Contribution Tiers" icon={Users}
        items={configData.shgContributionTiers}
        category="shgContributionTiers"
        fields={['fund_type_display', 'wage_threshold_min', 'wage_threshold_max', 'contribution_amount']}
      />
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <ConfigCard {...cardProps} title="CPF PR Year Rates" icon={BarChart2}
        items={configData.cpfPrYearRates}
        category="cpfPrYearRates"
        fields={['pr_year', 'employee_rate', 'employer_rate']}
      />
      <ConfigCard {...cardProps} title="CPF Wage Ceilings" icon={DollarSign}
        items={configData.cpfWageCeilings}
        category="cpfWageCeilings"
        fields={['ow_monthly_ceiling', 'aw_annual_ceiling']}
      />
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <ConfigCard {...cardProps} title="IRAS Tax Brackets" icon={BarChart}
        items={configData.irasTaxBrackets}
        category="irasTaxBrackets"
        fields={['tax_year', 'bracket_min', 'bracket_max', 'tax_rate']}
      />
      <ConfigCard {...cardProps} title="IRAS Tax Reliefs" icon={CreditCard}
        items={configData.irasTaxReliefs}
        category="irasTaxReliefs"
        fields={['relief_name', 'tax_year', 'base_amount']}
      />
    </div>
    <ConfigCard {...cardProps} title="Insurance Policies" icon={Shield}
      items={configData.insurancePolicies}
      category="insurancePolicies"
      fields={['policy_type_display', 'coverage_amount']}
    />
  </div>
);

export default PayrollTab;
